module.exports = __webpack_public_path__ + "img/link_2.8edc0222.jpg";